import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ContentContainerProps {
  children: React.ReactNode;
}

const ContentContainer: React.FC<ContentContainerProps> = ({ children }) => {
  return <>{children}</>;
};

export default ContentContainer;
